var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartCion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9835 13.2529C19.3939 11.8708 20.8234 10.2141 20.8234 8.04635C20.8234 6.6655 20.2748 5.3412 19.2984 4.36479C18.322 3.38838 16.9977 2.83984 15.6169 2.83984C13.9508 2.83984 12.777 3.31316 11.357 4.73312C9.93704 3.31316 8.76321 2.83984 7.09713 2.83984C5.71628 2.83984 4.39198 3.38838 3.41558 4.36479C2.43917 5.3412 1.89063 6.6655 1.89062 8.04635C1.89062 10.2236 3.31058 11.8802 4.73054 13.2529L11.357 19.8793L17.9835 13.2529Z",
    stroke: "#FB2C36",
    strokeWidth: 1.89327,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCion);
export default __webpack_public_path__ + "static/media/heart-cion.3baa79a4d4d8ce3d86e7e4325d636ddc.svg";
export { ForwardRef as ReactComponent };